module.exports = __webpack_public_path__ + "static/media/picto-star-empty.b2d42a0a.svg";